


































import { computed, defineComponent, ref } from "@vue/composition-api";
import { Notification, NotificationType } from "@scrile/api-provider/dist/api/NotificationsProvider";
import { Participant, ParticipantNotificationDetails } from "@scrile/api-provider/dist/api/ParticipantProvider";
import providers from "@/lib/api";
import BaseButton from "@/components/BaseButton";
import ModalParticipantsManage from "@/components/PostCreate/views/MediaPostCreateView/components/ModalParticipantsManage.vue";
import ParticipantConsentRejectedConfirm from "./ParticipantConsentRejectedConfirm.vue";
import NotificationItemView from "../../NotificationItemView.vue";

export default defineComponent({
  name: "NotificationParticipantConsent",
  components: { BaseButton, ModalParticipantsManage, NotificationItemView, ParticipantConsentRejectedConfirm },
  props: {
    notification: { type: Object as () => Notification, required: true },
  },
  setup(props) {
    const showRejectedConfirm = ref(false);
    const showParticipantsModal = ref(false);
    const participants = ref<Participant[]>([]);
    const isRejected = computed(() => props.notification.type === NotificationType.PARTICIPANT_REJECTED);
    const textPath = computed(() =>
      isRejected.value ? "notificationsText.participantRejected" : "notificationsText.participantApproved"
    );
    const participant = computed(() => (props.notification.details as ParticipantNotificationDetails).participant);
    const postId = computed(() => participant.value?.postId);

    const fetchParticipants = async () => {
      if (!postId.value) return;
      const result = await providers.ParticipantProvider.search({
        data: { postIds: [postId.value] },
      });
      participants.value = [...result];
    };

    const manageParticipants = async () => {
      if (!postId.value) return;
      showRejectedConfirm.value = false;
      await fetchParticipants();
      showParticipantsModal.value = true;
    };

    return {
      isRejected,
      manageParticipants,
      participants,
      showParticipantsModal,
      showRejectedConfirm,
      textPath,
    };
  },
});
